import React from 'react';
import SplitSection from '../common/split-section';
import PromiseCardsSection from '../promise-cards-section';
import { PROMISE_CARDS_DATA } from '../promise-cards-section/constants';

const DesignedToDeliverSection: React.FC = () => {
  return (
    <section className="mt-40 mb-32 sm:mt-20 wg-container">
      <SplitSection
        heading="All our products are designed to deliver"
        headingClasses="w-1/2 flex items-center sm:w-full text-left mx-0 max-w-none"
        classname="w-full flex"
        child={
          <div className="w-1/2 sm:hidden">
            <img
              className="float-right sm:float-none"
              src="https://assets1.cleartax-cdn.com/cleartax/images/1620020271_1607343426_allproductsrhs.webp"
              alt="allproductsrhs"
              width="560"
              height="44"
              loading="lazy"
            />
          </div>
        }
      />
      <PromiseCardsSection promiseCards={PROMISE_CARDS_DATA} />
    </section>
  );
};

export default DesignedToDeliverSection;
